module.exports = __webpack_public_path__ + "img/ic-exclamation.5cfbbb7f.svg";